<template>
  <div class="enterprise-member-detail">
    <div class="enterprise-member-info">
      <el-card class="mb15" v-loading="loadingForm">
        <div slot="header" class="clearfix">
          <span class="fl">企业会员</span>
          <div class="fr"><el-button size="mini" type="link" @click="$router.go(-1)">返回</el-button></div>
        </div>
        <el-form :inline="true" :label-position="'right'" label-width="110px">
          <el-form-item label="成员名称">
            <div class="w200">{{ form.name }}</div>
          </el-form-item>
          <el-form-item label="微信昵称">
            <div class="w200">{{ form.nickName }}</div>
          </el-form-item>
          <el-form-item label="手机号">
            <div class="w200">{{ form.phoneNumber }}</div>
          </el-form-item>
          <el-form-item label="加盟时间">
            <div class="w200">{{ form.createTime }}</div>
          </el-form-item>
          <el-form-item label="会员数量">
            <div class="w200">{{ form.panelCount }}</div>
          </el-form-item>
          <el-form-item label="会员关注数量">
            <div class="w200">{{ form.panelFocusCount }}</div>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card>
        <el-table
          border
          v-loading="loading"
          :data="data"
          style="width: 100%"
        >
          <el-table-column label="用户名" align="center" prop="name" />
          <el-table-column label="手机号" align="center" prop="mobilePhone" />
          <el-table-column label="Openid" align="center" prop="openId" />
          <el-table-column label="所属企业" align="center" prop="enterpriseName" />
          <el-table-column label="所属合伙人" align="center" prop="parentName" />
          <el-table-column label="合伙人电话" align="center" prop="parentPhone" />
          <el-table-column label="创建时间" align="center" prop="createTime" />
          <el-table-column label="公众号状态" align="center" width="120" prop="state">
            <template slot-scope="scope">
              <span v-text="scope.row.isSubscribe?'已关注':'未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}" />
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
          <el-pagination
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="params.pageIndex"
            :page-sizes="[2, 4, 10, 20, 50, 100]"
            :page-size="params.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { managerPartner as getDetail, managerEnterpriseMemberPanelList as getList } from 'api/request'
  export default {
    name: 'DevCommissionerDetail',
    data() {
      return {
        loadingForm: false,
        loading: false,
        id: this.$route.query.id,
        params: {
          partnerId: this.$route.query.id,
          pageIndex: 1,
          pageSize: 10
        },
        data: [],
        total: 0,
        form: {},
        acTabName: '0',
      }
    },
    mounted() {
      this.getDetail()
      this.getList(true)
    },
    methods: {
      async getDetail() {
        this.loadingForm = true
        const id = this.id
        const res = await getDetail({ id })
        if (res) {
          this.form = res
        }
        this.loadingForm = false
      },
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
        this.loadingForm = false
      },
      sizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
    }
  }
</script>

<style scoped lang="scss">
  .enterprise-member-detail{
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .mb15{
      margin-bottom: 15px;
    }
    .el-form{
      .el-form-item{
        margin-bottom: 0;
      }
    }
    .w200{
      width: 200px;
    }
  }
</style>

